import { CiapCidSelectModel, isCiap } from 'components/form/field/select/CiapCidSelectField/CiapCidSelectField'
import {
  AcompanhamentoCondicaoSaudeQueryInput,
  FaixaEtariaEnum,
  FaixaEtariaInput,
  TipoFiltroLpcEnum,
} from 'graphql/types.generated'
import { isNumber, partition } from 'lodash'
import { idGrupoCondicao } from 'types/enums'
import { isUndefinedOrNull } from 'util/checks'
import { isEmpty } from 'util/validation/Util'

import { convertFaixaEtariaAcompanhamentoInput } from '../converter/converter-faixaEtariaAcompanhamento'
import {
  AcompanhamentoCondicaoSaudeFormModel,
  faixaEtariaRecord,
  ResultadosTriaEnum,
} from './model/model-acompanhamentoCondicaoSaude'

export function convertAcompanhamentoCondicaoSaudeModelToQueryInput(
  model: AcompanhamentoCondicaoSaudeFormModel
): AcompanhamentoCondicaoSaudeQueryInput {
  const { filtrosAvancados = {} } = model ?? {}

  const [ciaps, cids] = partition(filtrosAvancados.problemasCondicoes, (item) => isCiap(item))

  return {
    ciaps: ciaps.map((item: CiapCidSelectModel) => item.codigo),
    cid10: cids.map((item: CiapCidSelectModel) => item.codigo),
    grupoCondicao: filtrosAvancados.grupoCondicao?.map((item) => idGrupoCondicao[item.grupo]),
    tipoFiltroLPC: tipoFiltroLPCConverter(model),
    unidadeResponsavelId: model?.unidadeResponsavelId,
    equipeResponsavelId: model?.equipeResponsavel?.id,
    sexo: filtrosAvancados.sexo,
    identidadeGenero: filtrosAvancados.identidadeGenero,
    faixaEtaria: convertFaixaEtariaAcompanhamentoInput(filtrosAvancados.tipoFaixaEtaria, mountFaixaEtaria(model)),
    periodoUltimoAtendimento: filtrosAvancados.periodoUltimoAtendimento,
    microareas: model?.microareas,
    periodoCadastroIndividual: model?.tria?.periodoRegistro,
    riscoInsegurancaAlimentar: !isEmpty(model.tria)
      ? model.tria.resultadosTria === ResultadosTriaEnum.RISCO_DE_INSEGURANCA_ALIMENTAR
      : undefined,
    semRegistroTriaNoPeriodo: !isEmpty(model.tria)
      ? model.tria.resultadosTria === ResultadosTriaEnum.SEM_REGISTRO_TRIA_NO_PERIODO
      : undefined,
    ivcf: !isUndefinedOrNull(filtrosAvancados.ivcf)
      ? {
          exibirApenasCidadaosIdososSemIvcf: filtrosAvancados.ivcf?.exibirApenasCidadaosIdososSemIvcf,
          pontuacaoMin: filtrosAvancados.ivcf?.pontuacao?.firstValue,
          pontuacaoMax: filtrosAvancados.ivcf?.pontuacao?.secondValue,
          riscoVulnerabilidade: !isEmpty(filtrosAvancados.ivcf?.riscoVulnerabilidade)
            ? filtrosAvancados.ivcf?.riscoVulnerabilidade
            : undefined,
          subgrupo: filtrosAvancados.ivcf?.subgrupo,
        }
      : null,
    tematica: model?.tematica,
    pageParams: {
      ...model?.pageParams,
      sort: model?.pageParams?.sort ?? ['microarea', 'cidadao', 'endereco'],
    },
    racaCor: filtrosAvancados?.racaCor?.value,
  }
}

function mountFaixaEtaria(model: AcompanhamentoCondicaoSaudeFormModel): FaixaEtariaInput {
  const {
    filtrosAvancados: { tipoFaixaEtaria, faixaEtariaRange },
  } = model

  return tipoFaixaEtaria !== FaixaEtariaEnum.OUTRA
    ? faixaEtariaRecord[tipoFaixaEtaria]
    : {
        idadeMinima: faixaEtariaRange?.firstValue,
        idadeMaxima: faixaEtariaRange?.secondValue,
        tipoFaixaEtaria:
          isNumber(faixaEtariaRange?.firstValue) || isNumber(faixaEtariaRange?.secondValue)
            ? faixaEtariaRange?.tipoFaixaEtaria
            : null,
      }
}

function tipoFiltroLPCConverter(model: AcompanhamentoCondicaoSaudeFormModel): TipoFiltroLpcEnum {
  const { filtrosAvancados } = model ?? {}

  return filtrosAvancados?.ativoListaProblema && !filtrosAvancados.naoIncluidoListaProblema
    ? TipoFiltroLpcEnum.SOMENTE_ATIVOS_LPC
    : !filtrosAvancados.ativoListaProblema && filtrosAvancados.naoIncluidoListaProblema
    ? TipoFiltroLpcEnum.SOMENTE_NAO_INCLUIDOS_LPC
    : TipoFiltroLpcEnum.TODOS
}
